import { useState } from 'react';
import { faqList } from '@/mocks/anime';
import SchemaOrg from '@/components/feature/SchemaOrg';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchemaData = {
    mainEntity: faqList.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <SchemaOrg type="FAQPage" data={faqSchemaData} />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于奶泡动漫，你可能想了解这些</p>
        </div>

        <div className="space-y-3">
          {faqList.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 text-lg flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}